module.exports = __webpack_public_path__ + "static/media/agency-skill.12d03829.jpg";